/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:44:54
 * @LastEditTime: 2022-07-15 16:52:44
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
import Vue from 'vue'
const $axios = axios.create({
  baseURL: '',
  timeout: 30000,
})

// http request 拦截器
$axios.interceptors.request.use(
  (config) => {
    // 根据最外层域名判断医院编码
    let hospitalCode= localStorage.getItem("HospitalCode")
    config.headers['userToken'] = !localStorage.getItem('ut')?"":localStorage.getItem('ut')
    config.headers['langCode'] = 'zh'
    config.headers['longitude'] = localStorage.getItem('longitude') || 31.94619 // 纬度，浮点数，范围为90 ~ -90
    config.headers['latitude'] = localStorage.getItem('latitude') || 117.37915 // 经度，浮点数，范围为180 ~ -180。
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      let data = config.data || {}
      // data.hospitalCode = hospitalCode
      config.data = data
    } else if (config.method === 'get') {
      let params = config.params || {}
      params.hospitalCode = hospitalCode
      config.params = params
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)
// http response 拦截器
$axios.interceptors.response.use(
  (response) => {
    console.log(response)
    if (response.status !== 200) {
      message.error('接口请求失败，请稍后再试！')
      return Promise.reject(response)
    } else if (response.data.code == '9999') {
      message.error(response.data.msg)
    } else if ((!response.data || response.data.code !== '0')&&response.config.responseType!=="arraybuffer") {
      console.log(window.parent)
      message.error(response.data.msg)
      return Promise.reject(response.data)
    }
    return response.data || {}
  },
  (error) => {
    console.log(error.response)
    if (error.response && error.response.status === 404) {
      message.error('找不到接口了：' + error.response.config.url)
    }
    return Promise.reject(error)
  }
)
export default $axios